import { Grid, Tooltip as TooltipComposant } from '@mairistem/composants';
import { formatMontant } from '@mairistem/finances-utils';
import { clamp } from 'lodash';
import React from 'react';
import TypeBudget from '../../../constants/simulation/typeBudget';
import type PanelProps from '../../../interfaces/simulation/panelProps';
import EpargneChart from './EpargneChart';
import './EpargnePanel.css';

const EpargneBrute = ({ data, tooltip }: PanelProps) => {
	const epargneBrute = data?.epargneBrute ?? 0;
	const recetteReelFonctionnement = data?.recetteReelFonctionnement ?? 0;
	const taux = clamp(
		recetteReelFonctionnement > 0
			? (epargneBrute * 100) / recetteReelFonctionnement
			: 0,
		0,
		100,
	);

	const chartData = [
		{
			name: 'Epargne Brute N-2',
			value: data.exercicePrecedent2.epargneBrute ?? 0,
		},
		{
			name: 'Epargne Brute N-1',
			value: data.exercicePrecedent.epargneBrute ?? 0,
		},
		{ name: 'Epargne Brute', value: epargneBrute },
	];

	return (
		<Grid>
			<Grid.Row>
				<Grid.Column width={10}>
					<TooltipComposant
						message={tooltip}
						trigger={
							<div className="bold indicateurTitle">
								{`Epargne brute ${data?.anneeExercice}`}
							</div>
						}
						type="information"
					/>

					<br />
					<br />
					{`${data?.typeBudget === TypeBudget.COMPTE_ADMINISTRATIF ? 'Réalisations' : 'Prévisions'} :`}
					<br />
					<span data-testid="epargneBrute">{formatMontant(epargneBrute)}</span>
					<br />
					<br />
					<span data-testid="tauxEpargneBrute">{`Taux: ${taux?.toFixed(2)}%`}</span>
				</Grid.Column>
				<Grid.Column className="epargneChartContainer" width={6}>
					<EpargneChart data={chartData} epargne={epargneBrute} />
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

export default EpargneBrute;
